<template>
  <b-breadcrumb fluid="lg" class="breadcrumb-sistemacpv">
    <b-breadcrumb-item :to="{ name: 'landing' }" class="text-decoration-none">
      {{ mainSite }}
    </b-breadcrumb-item>
    <b-breadcrumb-item v-if="this.$route.meta.section_name == 'area_restrict'" :active="this.$route.name == 'home'"
      :to="{ name: 'home' }" class="text-decoration-none">
      {{ segmentsContent }}
    </b-breadcrumb-item>
    <b-breadcrumb-item active aria-current="page" class="text-uppercase font-weight-normal"
      v-if="this.$route.name != 'home'">{{ $route.meta.title || title }}</b-breadcrumb-item>
  </b-breadcrumb>
</template>

<script>
export default {
  props: ['title', 'url'],
  computed: {
    mainSite: function () {
      if (this.$route.meta.section_name) {
        return 'SISTEMA DE ENSINO CPV';
      } else {
        return 'SISTEMA CPV';
      }
    },
    segmentsContent: function () {
      if (this.$route.meta.section_name === 'area_restrict') {
        return 'CONTEÚDO EXCLUSIVO';
      } else {
        return 'ERROR';
      }
    },
  },
};
</script>